var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:[_vm.cardBackground],style:(_vm.cardStyle)},[_vm._t("cardContent")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }